var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWardrobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cupboard",
    clipPath: "url(#clip0_314_418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cupboard_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 346",
    d: "M4.51791 23.6364H2.30664V22.0723H5.57955C4.7664 22.5067 4.31873 23.01 4.51791 23.6364Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 347",
    d: "M15.4816 23.6364H17.6928V22.0723H14.4199C15.2331 22.5067 15.6807 23.01 15.4816 23.6364Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 348",
    d: "M11.0169 14.5688H17.0058C17.0745 14.5688 17.1405 14.5414 17.1891 14.4926C17.2377 14.4439 17.265 14.3778 17.265 14.3089V3.92827C17.265 3.85935 17.2377 3.79325 17.1891 3.74451C17.1405 3.69577 17.0745 3.6684 17.0058 3.6684H11.0169C10.9482 3.6684 10.8823 3.69577 10.8337 3.74451C10.7851 3.79325 10.7578 3.85935 10.7578 3.92827V14.3098C10.7581 14.3786 10.7855 14.4445 10.8341 14.493C10.8826 14.5415 10.9484 14.5688 11.0169 14.5688Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 349",
    d: "M9.24542 14.3098V3.92827C9.24542 3.85935 9.21811 3.79325 9.16952 3.74451C9.12092 3.69577 9.05502 3.6684 8.98629 3.6684H2.99741C2.92869 3.6684 2.86278 3.69577 2.81418 3.74451C2.76559 3.79325 2.73828 3.85935 2.73828 3.92827V14.3098C2.73828 14.3788 2.76559 14.4449 2.81418 14.4936C2.86278 14.5423 2.92869 14.5697 2.99741 14.5697H8.98629C9.05502 14.5697 9.12092 14.5423 9.16952 14.4936C9.21811 14.4449 9.24542 14.3788 9.24542 14.3098Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 350",
    d: "M10.7578 16.3782V20.4654C10.7578 20.5344 10.7851 20.6005 10.8337 20.6492C10.8823 20.6979 10.9482 20.7253 11.0169 20.7253H17.0058C17.0745 20.7253 17.1405 20.6979 17.1891 20.6492C17.2377 20.6005 17.265 20.5344 17.265 20.4654V16.3782C17.265 16.3092 17.2377 16.2431 17.1891 16.1944C17.1405 16.1457 17.0745 16.1183 17.0058 16.1183H11.0169C10.9482 16.1183 10.8823 16.1457 10.8337 16.1944C10.7851 16.2431 10.7578 16.3092 10.7578 16.3782Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe 443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ligne 23",
    d: "M7.82129 9.83466V10.3059",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne 24",
    d: "M12.1787 9.83466V10.3059",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ligne 25",
    d: "M5.82422 17.2975H6.23321",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne 26",
    d: "M13.7676 17.2975H14.1766",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 351",
    d: "M2.73535 19.0972V20.4654C2.73535 20.5344 2.76266 20.6005 2.81125 20.6492C2.85985 20.6979 2.92576 20.7253 2.99448 20.7253H8.98336C9.05208 20.7253 9.11799 20.6979 9.16659 20.6492C9.21518 20.6005 9.24249 20.5344 9.24249 20.4654V16.3782C9.24249 16.3092 9.21518 16.2431 9.16659 16.1944C9.11799 16.1457 9.05208 16.1183 8.98336 16.1183H2.99448C2.92576 16.1183 2.85985 16.1457 2.81125 16.1944C2.76266 16.2431 2.73535 16.3092 2.73535 16.3782V17.7493",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 352",
    d: "M18.6079 14.3185V2.31952H1.38965V21.6785C1.38965 21.7302 1.3998 21.7814 1.41953 21.8292C1.43926 21.877 1.46818 21.9204 1.50463 21.9569C1.54108 21.9935 1.58435 22.0225 1.63198 22.0423C1.67961 22.0621 1.73066 22.0722 1.78221 22.0722H18.2192C18.2708 22.0722 18.3218 22.0621 18.3695 22.0423C18.4171 22.0225 18.4604 21.9935 18.4968 21.9569C18.5333 21.9204 18.5622 21.877 18.5819 21.8292C18.6016 21.7814 18.6118 21.7302 18.6118 21.6785V15.679",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 353",
    d: "M3.96878 0.363647H0.362305L1.39784 2.31953H18.6016L19.6371 0.363647H5.32725",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_314_418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWardrobe);
export default __webpack_public_path__ + "static/media/wardrobe.1dccc0e1e1dc8b485546f39daaf44522.svg";
export { ForwardRef as ReactComponent };